"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionJsonData = exports.Auction = exports.AuctionState = void 0;
var image_set_1 = require("./image-set");
var AuctionState;
(function (AuctionState) {
    AuctionState["NEW"] = "new";
    AuctionState["UPCOMING"] = "upcoming";
    AuctionState["CURRENT"] = "current";
    AuctionState["COMPLETED"] = "completed";
    AuctionState["ARCHIVED"] = "archived";
    AuctionState["CANCELLED"] = "cancelled";
})(AuctionState = exports.AuctionState || (exports.AuctionState = {}));
var Auction = /** @class */ (function () {
    function Auction() {
        this.salePrice = 0;
        this.createdDate = 0;
        this.images = new image_set_1.ImageSet();
    }
    return Auction;
}());
exports.Auction = Auction;
/**
 * Model that is used when storing to Firebase
 */
var AuctionJsonData = /** @class */ (function () {
    function AuctionJsonData() {
        this.state = AuctionState.NEW;
        this.nftTokenId = '';
        this.salePrice = 0;
        this.nftUrl = '';
        this.createdDate = 0;
        this.images = new image_set_1.ImageSet();
    }
    return AuctionJsonData;
}());
exports.AuctionJsonData = AuctionJsonData;
;
